module.exports = __webpack_public_path__ + "img/SuperfluidLabs-white-logo-01-01.b1d66d45.png";